const MEMBERSHIP_LOADING = "MEMBERSHIP_LOADING";
const MEMBERSHIP_ERROR = "MEMBERSHIP_ERROR";
const MEMBERSHIP_SUCCESS = "MEMBERSHIP_SUCCESS";

export { MEMBERSHIP_LOADING, MEMBERSHIP_ERROR, MEMBERSHIP_SUCCESS };